<template>
  <div class="page">
    <router-view></router-view>
    <MyFooter />
  </div>
</template>

<script>
import MyFooter from '../components/general/Footer'

export default {
  name: "Layout",
  components: { MyFooter },
  watch: {
    '$route': {
      handler() {
        window._paq.push(['setUserId', this.$store.getters.user.email])
        window._paq.push(['setCustomDimension', 1, this.$store.getters.selectedCompanyName])
        window._paq.push(['setCustomDimension', 2, this.$store.getters.selectedCompanyName])
      }
    },
  },
  mounted() {
    // // if(!this.$store.getters.token) {
    // //   this.$router.push('/company-select')
    // // }
    // // this.$store.dispatch('getUserInfo', this.$store.getters.selectedCompanyId)
    // console.log(this.$store.getters.user)
    window._paq.push(['setUserId', this.$store.getters.user.email])
    window._paq.push(['setCustomDimension', 1, this.$store.getters.selectedCompanyName])
    window._paq.push(['setCustomDimension', 2, this.$store.getters.selectedCompanyName])
  }
}
</script>
